
export type DifficultyRank = 'quick_win' | 'simple' | 'moderate' | 'challenging' | 'major';

export interface DifficultyConfig {
  rank: DifficultyRank;
  label: string;
  description: string;
  pips: number;
  xpMultiplier: number;
  color: string;
  rpgColor: string;
}

export const DIFFICULTY_CONFIGS: Record<DifficultyRank, DifficultyConfig> = {
  quick_win: {
    rank: 'quick_win',
    label: 'Quick Win',
    description: 'A small step forward',
    pips: 3,
    xpMultiplier: 1,
    color: 'text-green-600',
    rpgColor: 'text-emerald-400'
  },
  simple: {
    rank: 'simple',
    label: 'Simple',
    description: 'Easy to tackle',
    pips: 5,
    xpMultiplier: 1.5,
    color: 'text-blue-600',
    rpgColor: 'text-blue-400'
  },
  moderate: {
    rank: 'moderate',
    label: 'Moderate',
    description: 'Standard challenge',
    pips: 7,
    xpMultiplier: 2,
    color: 'text-yellow-600',
    rpgColor: 'text-yellow-400'
  },
  challenging: {
    rank: 'challenging',
    label: 'Challenging',
    description: 'Requires focused effort',
    pips: 10,
    xpMultiplier: 3,
    color: 'text-orange-600',
    rpgColor: 'text-orange-400'
  },
  major: {
    rank: 'major',
    label: 'Major',
    description: 'A significant undertaking',
    pips: 12,
    xpMultiplier: 4,
    color: 'text-red-600',
    rpgColor: 'text-red-400'
  }
};

export const getDifficultyConfig = (rank?: DifficultyRank | null): DifficultyConfig => {
  if (!rank) return DIFFICULTY_CONFIGS.moderate; // Default to moderate for existing entries
  return DIFFICULTY_CONFIGS[rank];
};

export const getDifficultyByPips = (pips: number): DifficultyConfig => {
  const config = Object.values(DIFFICULTY_CONFIGS).find(config => config.pips === pips);
  return config || DIFFICULTY_CONFIGS.moderate;
};
